// import React, { useState, useRef } from "react";
// import axios from "axios";
// import { Send, Paperclip, X } from "lucide-react";

// const API_URL = process.env.REACT_APP_API_BASE_URL;

// export default function LeadReplyForm({ conversationId, contactEmail, defaultSubject, onSent }) {
//   const [replyText, setReplyText] = useState("");
//   const [replySubject, setReplySubject] = useState(
//     defaultSubject ? `Re: ${defaultSubject}` : "Re: Ваше письмо"
//   );
//   const [attachments, setAttachments] = useState([]);
//   const [sending, setSending] = useState(false);
//   const fileInputRef = useRef(null);

//   const handleFileSelect = (e) => {
//     const files = Array.from(e.target.files);
//     const newAttachments = files.map(file => ({
//       name: file.name,
//       size: file.size,
//       file: file,
//     }));
//     setAttachments(prev => [...prev, ...newAttachments]);
//     e.target.value = "";
//   };

//   const removeAttachment = (index) => {
//     setAttachments(prev => prev.filter((_, i) => i !== index));
//   };

//   const readFileAsBase64 = (file) => {
//     return new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.onload = () => resolve(reader.result);
//       reader.onerror = reject;
//       reader.readAsDataURL(file);
//     });
//   };

//   const formatFileSize = (bytes) => {
//     if (bytes < 1024) return bytes + " Б";
//     if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " КБ";
//     return (bytes / (1024 * 1024)).toFixed(1) + " МБ";
//   };

//   const handleSend = async () => {
//     if (!replyText.trim() && attachments.length === 0) {
//       alert("Введите текст ответа или прикрепите файл");
//       return;
//     }
//     if (!conversationId) {
//       alert("Нет привязанной переписки");
//       return;
//     }

//     setSending(true);
//     try {
//       const attachmentsData = [];
//       for (const att of attachments) {
//         const base64 = await readFileAsBase64(att.file);
//         const base64Data = base64.split(",")[1] || base64;
//         attachmentsData.push({
//           filename: att.name,
//           content: base64Data,
//           contentType: att.file.type || "application/octet-stream",
//         });
//       }

//       const response = await axios.post(
//         `${API_URL}/api/reply`,
//         {
//           conversationId,
//           text: replyText,
//           subject: replySubject,
//           attachments: attachmentsData,
//         },
//         { withCredentials: true }
//       );

//       if (response.data.success) {
//         setReplyText("");
//         setAttachments([]);
//         if (onSent) onSent(response.data);
//       }
//     } catch (err) {
//       console.error("Ошибка отправки:", err);
//       alert("Не удалось отправить: " + (err.response?.data?.error || err.message));
//     } finally {
//       setSending(false);
//     }
//   };

//   return (
//     <div className="border-t border-gray-200 pt-3 mt-3">
//       <div className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
//         Ответить
//       </div>

//       <div className="space-y-2">
//         <input
//           type="text"
//           value={replySubject}
//           onChange={(e) => setReplySubject(e.target.value)}
//           placeholder="Тема"
//           className="w-full border border-gray-300 rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
//         />

//         <textarea
//           value={replyText}
//           onChange={(e) => setReplyText(e.target.value)}
//           rows={3}
//           placeholder="Введите текст ответа..."
//           className="w-full border border-gray-300 rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400 resize-none"
//         />

//         {attachments.length > 0 && (
//           <div className="flex flex-wrap gap-1.5">
//             {attachments.map((att, index) => (
//               <div
//                 key={index}
//                 className="flex items-center gap-1.5 bg-gray-50 border border-gray-200 rounded-lg px-2 py-1 text-xs"
//               >
//                 <Paperclip size={11} />
//                 <span className="truncate max-w-[120px]">{att.name}</span>
//                 <span className="text-[10px] text-gray-400">
//                   ({formatFileSize(att.size)})
//                 </span>
//                 <button
//                   onClick={() => removeAttachment(index)}
//                   className="text-red-500 hover:text-red-700"
//                 >
//                   <X size={12} />
//                 </button>
//               </div>
//             ))}
//           </div>
//         )}

//         <div className="flex gap-2">
//           <button
//             onClick={() => fileInputRef.current?.click()}
//             className="px-3 py-2 rounded-xl bg-white border border-gray-300 hover:bg-gray-100 transition text-sm flex items-center gap-1.5"
//             title="Прикрепить файл"
//           >
//             <Paperclip size={14} />
//             <span className="hidden md:inline">Файл</span>
//           </button>
//           <input
//             ref={fileInputRef}
//             type="file"
//             accept=".pdf,.doc,.docx,.png,.jpg,.jpeg,.txt,.xls,.xlsx,.ppt,.pptx"
//             multiple
//             onChange={handleFileSelect}
//             className="hidden"
//           />

//           <button
//             onClick={handleSend}
//             disabled={sending}
//             className="flex-1 px-3 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-700 transition disabled:opacity-50 text-sm font-medium flex items-center justify-center gap-2"
//           >
//             <Send size={14} />
//             {sending ? "Отправка..." : "Отправить"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState, useRef } from "react";
import axios from "axios";
import { Send, Paperclip, X } from "lucide-react";

const API_URL = process.env.REACT_APP_API_BASE_URL;

export default function LeadReplyForm({ conversationId, contactEmail, defaultSubject, onSent }) {
  const [replyText, setReplyText] = useState("");
  const [replySubject, setReplySubject] = useState(
    defaultSubject ? `Re: ${defaultSubject}` : "Re: Ваше письмо"
  );
  const [attachments, setAttachments] = useState([]);
  const [sending, setSending] = useState(false);
  const fileInputRef = useRef(null);

  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files);
    const newAttachments = files.map(file => ({
      name: file.name,
      size: file.size,
      file: file,
    }));
    setAttachments(prev => [...prev, ...newAttachments]);
    e.target.value = "";
  };

  const removeAttachment = (index) => {
    setAttachments(prev => prev.filter((_, i) => i !== index));
  };

  const readFileAsBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  const formatFileSize = (bytes) => {
    if (bytes < 1024) return bytes + " Б";
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " КБ";
    return (bytes / (1024 * 1024)).toFixed(1) + " МБ";
  };

  const handleSend = async () => {
    if (!replyText.trim() && attachments.length === 0) {
      alert("Введите текст ответа или прикрепите файл");
      return;
    }
    if (!conversationId) {
      alert("Нет привязанной переписки");
      return;
    }

    setSending(true);
    try {
      const attachmentsData = [];
      for (const att of attachments) {
        const base64 = await readFileAsBase64(att.file);
        const base64Data = base64.split(",")[1] || base64;
        attachmentsData.push({
          filename: att.name,
          content: base64Data,
          contentType: att.file.type || "application/octet-stream",
        });
      }

      const response = await axios.post(
        `${API_URL}/api/reply`,
        {
          conversationId,
          text: replyText,
          subject: replySubject,
          attachments: attachmentsData,
        },
        { withCredentials: true }
      );

      if (response.data.success) {
        setReplyText("");
        setAttachments([]);
        if (onSent) onSent(response.data);
      }
    } catch (err) {
      console.error("Ошибка отправки:", err);
      alert("Не удалось отправить: " + (err.response?.data?.error || err.message));
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="border-t border-gray-200 pt-3 mt-3">
      <div className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
        Ответить
      </div>

      <div className="space-y-2">
        <input
          type="text"
          value={replySubject}
          onChange={(e) => setReplySubject(e.target.value)}
          placeholder="Тема"
          className="w-full border border-gray-300 rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
        />

        <textarea
          value={replyText}
          onChange={(e) => setReplyText(e.target.value)}
          rows={3}
          placeholder="Введите текст ответа..."
          className="w-full border border-gray-300 rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400 resize-none"
        />

        {attachments.length > 0 && (
          <div className="flex flex-wrap gap-1.5">
            {attachments.map((att, index) => (
              <div
                key={index}
                className="flex items-center gap-1.5 bg-gray-50 border border-gray-200 rounded-lg px-2 py-1 text-xs"
              >
                <Paperclip size={11} />
                <span className="truncate max-w-[120px]">{att.name}</span>
                <span className="text-[10px] text-gray-400">
                  ({formatFileSize(att.size)})
                </span>
                <button
                  onClick={() => removeAttachment(index)}
                  className="text-red-500 hover:text-red-700"
                >
                  <X size={12} />
                </button>
              </div>
            ))}
          </div>
        )}

        <div className="flex gap-2">
          <button
            onClick={() => fileInputRef.current?.click()}
            className="px-3 py-2 rounded-xl bg-white border border-gray-300 hover:bg-gray-100 transition text-sm flex items-center gap-1.5"
            title="Прикрепить файл"
          >
            <Paperclip size={14} />
            <span className="hidden md:inline">Файл</span>
          </button>
          <input
            ref={fileInputRef}
            type="file"
            accept=".pdf,.doc,.docx,.png,.jpg,.jpeg,.txt,.xls,.xlsx,.ppt,.pptx"
            multiple
            onChange={handleFileSelect}
            className="hidden"
          />

          <button
            onClick={handleSend}
            disabled={sending}
            className="flex-1 px-3 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-700 transition disabled:opacity-50 text-sm font-medium flex items-center justify-center gap-2"
          >
            <Send size={14} />
            {sending ? "Отправка..." : "Отправить"}
          </button>
        </div>
      </div>
    </div>
  );
}